import script from "./withdrawalAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./withdrawalAdmin.vue?vue&type=script&setup=true&lang=js"

import "./withdrawalAdmin.vue?vue&type=style&index=0&id=32677bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32677bf6"]])

export default __exports__